import React, { useEffect, useState } from 'react'
import toast, { Toaster } from 'react-hot-toast'
import { VegRequirementFilter } from '../../components/Filter/VegRequirementFilter';
import axios from 'axios';
import { baseUrl } from '../../comman/config';
import Select from 'react-select';
import Loader from "../../components/Loader.js";
import NoRecordsFound from "../../components/NoRecordsFound.js";


function ReceiptNetList() {
  const today = new Date().toISOString().split("T")[0];
  const [ingredientReceiptList, setIngredientReceiptList] = useState([]);
  const [fromDate, setFromDate] = useState("");
  const [toDate, setToDate] = useState("");
  const [selectAll, setSelectAll] = useState(false);
  const [selectedRows, setSelectedRows] = useState([]);
  const [receiptStatus, setReceiptStatus] = useState([]);
  const [ingredient, setIngredient] = useState([]);
  const [ingredientList, setIngredientList] = useState([]);
  const [loading, setLoading] = useState(false)
  const [noRecordsFound, setNoRecordsFound] = useState(false);
  
  useEffect(() => {
    getIngredientReceiptList();
  }, [fromDate, toDate, ingredient, receiptStatus])

  useEffect(()=>{
    console.log(ingredientReceiptList)
    getIngredientList()
  },[ingredientReceiptList])

  const handelFilterChange = async (from_date, to_date, session, item, requirement_status, order_status, order_id, purchase_status, receipt_status, issue_status, ingredient) => {
    setFromDate(from_date);
    setToDate(to_date);
    // setIngredient(ingredient); 
    // setReceiptStatus(receipt_status);
    setIngredient(Array.isArray(ingredient) ? ingredient : ingredient ? [ingredient] : []);
    setReceiptStatus(Array.isArray(receipt_status) ? receipt_status : receipt_status ? [receipt_status] : []);
  };

  const getIngredientList = async () => {
    const response = await axios.get(`${baseUrl}/ingredients/list?limit=all`);
    const existingIngredientIds = ingredientReceiptList.map(item => item.ingredient_id);
    const list = response.data.data.filter((item) => item.status == 1 && item?.store?.id == 3 && !existingIngredientIds.includes(item.id));
    setIngredientList(list);
  };

  const getIngredientReceiptList = async() => {
    setLoading(true)
    setNoRecordsFound(false)
    const ingredientArr = Array.isArray(ingredient) ? ingredient : ingredient ? [ingredient] : [];
    const receiptStatusArr = Array.isArray(receiptStatus) ? receiptStatus : receiptStatus ? [receiptStatus] : [];
    const ingredientIds = ingredientArr.map(i => i.value).join(',');
    const receiptStatusValues = receiptStatusArr.map(s => s.value).join(',');
    console.log("receipt value:", receiptStatus.value)
    const response = await axios.post(`${baseUrl}/receipt_net/list`,
      { from_date : fromDate,
        to_date :toDate,
        ingredient : ingredientIds,
        receipt_status : receiptStatusValues
      
    });
    const updatedArray = response?.data?.data.map(item => ({
      ...item,         // Spread existing properties
      rec_net_qty: item.rec_net_qty ?? "",        // Add new key-value pair
      add_rec_net:false,
  }));
    setIngredientReceiptList(updatedArray);
    setNoRecordsFound(updatedArray.length === 0);
    setLoading(false)
  }

  const handleToggleSelect = (index) => {
    const updatedSelectedRows = selectedRows.includes(ingredientReceiptList[index])
        ? selectedRows.filter(item => item !== ingredientReceiptList[index]) // Deselect
        : [...selectedRows, ingredientReceiptList[index]]; // Select

   setSelectedRows(updatedSelectedRows);
  };

  const handleSwitchSelectAll = () => {
    if (selectAll) {
        setSelectedRows([]);
    } else {
        setSelectedRows(ingredientReceiptList.filter((item) => item.receipt_status == 2 || item.receipt_status == 3 || item.receipt_status == 4 )); // Select all rows
    }
    setSelectAll(!selectAll);
  };

  const handleInputChange = (index) => (e) => {
    const { name, value } = e.target;
    
    setIngredientReceiptList((prevFormData) => {
    //   if(name === 'rec_net_qty'){
        const updatedFormData = [...prevFormData];
        // const rec_net_qty = updatedFormData[index].rec_net_qty;
        updatedFormData[index] = { ...updatedFormData[index], [name]: value };
        return updatedFormData;
    //   }
    });
  };

  const handleAddButtonClick = (index, type) => {
    setIngredientReceiptList((prevFormData) => {
      const updatedFormData = [...prevFormData]
      const updatedItem = { ...updatedFormData[index] };
      updatedItem.add_rec_net = true;
      updatedFormData[index] = updatedItem;
      console.log(updatedFormData[index])
      return updatedFormData

    });

  }

  const handleSubmit = async() => {
    if(selectedRows.length == 0){
      alert("Please select at least one row");
      setSelectedRows([]);
      return;
    }
    console.log(selectedRows);

      // Check if net > gross and ask for confirmation
      if (checkNetExceedsGross(selectedRows)) {
          const confirmed = window.confirm("કેટલીક વસ્તુઓ માટે નેટ જથ્થો ગ્રોસ જથ્થા કરતાં વધુ છે. શું તમે આગળ વધવા માંગો છો??");
          if (!confirmed) {
              return;
          }
      }
    if(selectedRows.some(item => item.rec_net_qty === "")){
      alert("One or more items have an empty recieved qty value.");
      setSelectedRows([]);
      return;
    }
    if(selectedRows.some(item => item.add_rec_net_qty === "")){
      alert("One or more items have an empty additional recieved qty value.");
      setSelectedRows([]);
      return;
    }
    if(selectedRows.some(item => item.ingredient_id === null)){
      alert("One or more items have an empty ingredient value.");
      setSelectedRows([])
      return
    }
    if(selectedRows.length > 0){
      setLoading(true);
        try{
            const response = await axios.post(`${baseUrl}/receipt_net/ingredient_purchase`,
              { ingredientsList : selectedRows
                });
                const msg = response.data.msg;
                await getIngredientReceiptList();
                toast.success(msg);
                //await getIngredientReceiptList();
          }catch (error) {
            toast.error("Failed to add item. Please try again.");
          }finally {
      setLoading(false); // always stop loading
      setSelectedRows([]); // clear selection here for consistency
    }
    }
    // setSelectedRows([])
  };

    // Add this helper function to check if net > gross
    const checkNetExceedsGross = (list) => {
        return list.some(item => {
            const netQty = parseFloat(item.rec_net_qty) || 0;
            const grossQty = parseFloat(item.received_qty) || 0;
            return netQty > grossQty;
        });
    };

  const handleSave = async() => {
    const list = ingredientReceiptList.filter((item) => item.ingredient_id !== null);
    if(ingredientReceiptList.some(item => item.ingredient_id === null)){
      alert("One or more items have an empty ingredient value.");
      setSelectedRows([])
      return
    }

      // Check if net > gross and ask for confirmation
      if (checkNetExceedsGross(list)) {
          const confirmed = window.confirm("કેટલીક વસ્તુઓ માટે નેટ જથ્થો ગ્રોસ જથ્થા કરતાં વધુ છે. શું તમે આગળ વધવા માંગો છો??");
          if (!confirmed) {
              return;
          }
      }
    setLoading(true);
    if(list.length > 0){
      try{
        
        const response = await axios.post(`${baseUrl}/receipt_net/ingredient_save`,
          { 
            ingredientsList : list
          });
          toast.success("Data save sucessfully.");
          await getIngredientReceiptList();
      }catch (error) {
        toast.error("Failed to add item. Please try again.");
      } finally {
        setLoading(false)
        setSelectedRows([])
      }
    }
    
  }

  const handleAddNewIngredientRow = () => {
    setIngredientReceiptList([...ingredientReceiptList, {
      ingredient: '',
      ingredient_obj:{},
      ingredient_id: null,
      received_qty : 0,
      gross_required_qty: 0,
      rec_net_qty: '',
      purchase_status: 3,
      receipt_status: 4, 
      isNew: true
    }]);
  };

  const handleNewIngredientChange = (selectedOptions,index) => {
    // setNewIngredient((prev)=>({...prev,ingredient:ingredient}))
    console.log(selectedOptions)
    const updatedList =   [...ingredientReceiptList]
    updatedList[index].ingredient_obj = selectedOptions
    updatedList[index].ingredient = selectedOptions.ingredient
    updatedList[index].ingredient_id = selectedOptions.value
    setIngredientReceiptList(updatedList)
  }

  return (
    <div className="p-2 sm:p-4">
      {loading && <Loader />}
      <div className="flex justify-between items-center py-2 sm:py-4 px-2 sm:px-6">
        <h1 className="text-lg sm:text-xl font-bold">
          Veg Receipt (Net)
        </h1>

        <Toaster position="top-center" reverseOrder={false} />
      </div>

      <div className="relative shadow-md sm:rounded-lg">
        <VegRequirementFilter handleFilterChange={handelFilterChange} page="receipt" />
      </div>

      {noRecordsFound && <NoRecordsFound />}

      {ingredientReceiptList.length > 0 && (
        <div className="w-full">
          {/* Desktop Table View */}
          <div className="hidden md:block overflow-x-auto">
            <div className="max-w-full overflow-visible pb-2">
              <table className="w-full mt-4 text-sm text-left rtl:text-right text-gray-500 dark:text-gray-400 table-auto min-w-full">
                <thead className="text-xs text-gray-700 uppercase bg-gray-50 dark:bg-gray-700 dark:text-gray-400 sticky top-0">
                  <tr>
                    <th scope="col" className="px-2 py-1 border border-black text-center whitespace-nowrap">
                      <input
                        type="checkbox"
                        className="newrow checkboxAll"
                        onChange={handleSwitchSelectAll}
                        checked={selectAll}
                      />
                    </th>
                    <th scope="col" className="px-2 py-1 border border-black text-center whitespace-nowrap">શાકભાજીનું નામ</th>
                    <th scope="col" className="px-2 py-1 border border-black text-center whitespace-nowrap">માંગેલ (Req. qty.)</th>
                    <th scope="col" className="px-2 py-1 border border-black text-center whitespace-nowrap" colSpan='2'>મળેલ (Received qty)</th>
                    <th scope="col" className="px-2 py-1 border border-black text-center whitespace-nowrap">Receipt Status</th>
                  </tr>
                  <tr>
                    <th scope="col" className="px-2 py-1 border border-black text-center"></th>
                    <th scope="col" className="px-2 py-1 border border-black text-center"></th>
                    <th scope="col" className="px-2 py-1 border border-black text-center whitespace-nowrap">(ગ્રોસ) Gross</th>
                    <th scope="col" className="px-2 py-1 border border-black text-center whitespace-nowrap">(ગ્રોસ) Gross</th>
                    <th scope="col" className="px-2 py-1 border border-black text-center whitespace-nowrap">(નેટ) Net </th>
                    <th scope="col" className="px-2 py-1 border border-black text-center"></th>
                  </tr>
                </thead>
                <tbody>
                  {ingredientReceiptList.map((item, index) => (
                    <tr key={index} className="border border-black-b hover:bg-gray-50">
                      <td className="px-2 py-1 border border-black text-center">
                        <input
                          type="checkbox"
                          checked={selectedRows.includes(item)}
                          onChange={() => handleToggleSelect(index)}
                        />
                      </td>

                      <td className="px-2 py-1 border border-black text-center relative">
                        {item.isNew ? (
                          <Select
                            classNamePrefix="select"
                            className='basic-multi-select w-40 sm:w-auto'
                            value={item.ingredient_obj}
                            name="ingredient"
                            onChange={(selectedOptions) => handleNewIngredientChange(selectedOptions, index)}
                            options={ingredientList.map((item) => ({
                              value: item.id,
                              label: `${item.ingredient} (${item.eng_name})`,
                              unit: item.unit?.id,
                              ingredient: `${item.ingredient}`,
                              eng_name: item.eng_name,
                            }))}
                            placeholder="Ingredient List"
                            filterOption={(option, inputValue) => {
                              return option.data.label.toLowerCase().includes(inputValue.toLowerCase());
                            }}
                            menuPortalTarget={document.body}
                            menuPosition="fixed"
                            styles={{
                              menuPortal: (base) => ({
                                ...base,
                                zIndex: 9999
                              }),
                              menu: (base) => ({
                                ...base,
                                zIndex: 9999
                              })
                            }}
                          />
                        ) : (item.ingredient)}
                      </td>
                      <td className="px-0 py-1 border border-black text-center">
                        {item?.gross_required_qty ?? ''}
                      </td>
                      <td className="px-2 py-1 border border-black text-center">
                        {item?.received_qty ?? ''}
                      </td>
                      <td className="px-2 py-1 border border-black text-center">
                        <div className="flex flex-col sm:flex-row items-center justify-center space-y-1 sm:space-y-0 sm:space-x-1">
                          <input
                            type="number"
                            id="rec_net_qty"
                            name="rec_net_qty"
                            value={item?.rec_net_qty ?? ''}
                            onWheel={(e) => e.target.blur()}
                            onChange={handleInputChange(index)}
                            onKeyDown={(e) => {
                              if (e.key === 'ArrowUp' || e.key === 'ArrowDown') {
                                e.preventDefault();
                              }
                            }}
                            className={`px-2 py-1 border rounded-md w-20 ${(parseFloat(item.rec_net_qty) || 0) > (parseFloat(item.received_qty) || 0) ? 'border-red-500 bg-orange-50 border-2' : 'bg-orange-50'
                              }`}
                          />
                          {((item.receipt_status === 3 || item.receipt_status === 0 || item.receipt_status === 2 || item.receipt_status === 4) && item.rec_net_qty > 0) && (
                            <>
                              <button
                                onClick={() => { handleAddButtonClick(index, 1) }}
                                className='px-1 rounded border mx-2 scale-150 hover:bg-gray-300'
                              >
                                &#x2b;
                              </button>
                              {item.add_rec_net && (
                                <input
                                  type="number"
                                  id="add_rec_net_qty"
                                  name="add_rec_net_qty"
                                  value={item?.add_rec_net_qty ?? ''}
                                  onWheel={(e) => e.target.blur()}
                                  onChange={handleInputChange(index)}
                                  onKeyDown={(e) => {
                                    if (e.key === 'ArrowUp' || e.key === 'ArrowDown') {
                                      e.preventDefault();
                                    }
                                  }}
                                  className="px-2 py-1 border rounded-md w-20 bg-orange-50"
                                />
                              )}
                            </>
                          )}
                        </div>
                      </td>
                      <td className="px-2 py-1 border border-black text-center whitespace-nowrap">
                        {item.receipt_status == 1 ? "Pending Receipt" : (item.receipt_status == 2 ? "Partly Received" : (item.receipt_status == 3 ? "Received" : "Excess Received"))}
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>

          {/* Mobile Card View */}
          <div className="md:hidden mt-4">
            <div className="mb-4 flex justify-center">
              <label className="flex items-center space-x-2">
                <input
                  type="checkbox"
                  className="newrow checkboxAll"
                  onChange={handleSwitchSelectAll}
                  checked={selectAll}
                />
                <span className="text-sm font-medium">Select All</span>
              </label>
            </div>

            {ingredientReceiptList.map((item, index) => (
              <div key={index} className="bg-white border border-gray-200 rounded-lg shadow-sm mb-4 p-4">
                <div className="flex items-center justify-between mb-3">
                  <input
                    type="checkbox"
                    checked={selectedRows.includes(item)}
                    onChange={() => handleToggleSelect(index)}
                    className="scale-125"
                  />
                  <span className={`px-2 py-1 rounded-full text-xs font-medium ${item.receipt_status == 1 ? 'bg-yellow-100 text-yellow-800' :
                      item.receipt_status == 2 ? 'bg-orange-100 text-orange-800' :
                        item.receipt_status == 3 ? 'bg-green-100 text-green-800' :
                          'bg-red-100 text-red-800'
                    }`}>
                    {item.receipt_status == 1 ? "Pending Receipt" : (item.receipt_status == 2 ? "Partly Received" : (item.receipt_status == 3 ? "Received" : "Excess Received"))}
                  </span>
                </div>

                <div className="space-y-3">
                  <div>
                    <label className="block text-xs font-medium text-gray-700 mb-1">શાકભાજીનું નામ</label>
                    {item.isNew ? (
                      <Select
                        classNamePrefix="select"
                        className='basic-multi-select w-full'
                        value={item.ingredient_obj}
                        name="ingredient"
                        onChange={(selectedOptions) => handleNewIngredientChange(selectedOptions, index)}
                        options={ingredientList.map((item) => ({
                          value: item.id,
                          label: `${item.ingredient} (${item.eng_name})`,
                          unit: item.unit?.id,
                          ingredient: `${item.ingredient}`,
                          eng_name: item.eng_name,
                        }))}
                        placeholder="Ingredient List"
                        filterOption={(option, inputValue) => {
                          return option.data.label.toLowerCase().includes(inputValue.toLowerCase());
                        }}
                        menuPortalTarget={document.body}
                        menuPosition="fixed"
                        styles={{
                          menuPortal: (base) => ({
                            ...base,
                            zIndex: 9999
                          }),
                          menu: (base) => ({
                            ...base,
                            zIndex: 9999
                          })
                        }}
                      />
                    ) : (
                      <div className="p-2 bg-gray-50 rounded border text-sm">{item.ingredient}</div>
                    )}
                  </div>

                  <div className="grid grid-cols-2 gap-3">
                    <div>
                      <label className="block text-xs font-medium text-gray-700 mb-1">માંગેલ (Gross)</label>
                      <div className="p-2 bg-gray-50 rounded border text-sm text-center">
                        {item?.gross_required_qty ?? ''}
                      </div>
                    </div>
                    <div>
                      <label className="block text-xs font-medium text-gray-700 mb-1">મળેલ (Gross)</label>
                      <div className="p-2 bg-gray-50 rounded border text-sm text-center">
                        {item?.received_qty ?? ''}
                      </div>
                    </div>
                  </div>

                  <div>
                    <label className="block text-xs font-medium text-gray-700 mb-1">મળેલ (Net)</label>
                    <div className="flex items-center space-x-2">
                      <input
                        type="number"
                        id="rec_net_qty"
                        name="rec_net_qty"
                        value={item?.rec_net_qty ?? ''}
                        onWheel={(e) => e.target.blur()}
                        onChange={handleInputChange(index)}
                        onKeyDown={(e) => {
                          if (e.key === 'ArrowUp' || e.key === 'ArrowDown') {
                            e.preventDefault();
                          }
                        }}
                        className={`flex-1 px-2 py-2 border rounded-md ${(parseFloat(item.rec_net_qty) || 0) > (parseFloat(item.received_qty) || 0) ? 'border-red-500 bg-orange-50 border-2' : 'bg-orange-50'
                          }`}
                      />
                      {((item.receipt_status === 3 || item.receipt_status === 0 || item.receipt_status === 2 || item.receipt_status === 4) && item.rec_net_qty > 0) && (
                        <>
                          <button
                            onClick={() => { handleAddButtonClick(index, 1) }}
                            className='px-2 py-1 rounded border hover:bg-gray-300'
                          >
                            &#x2b;
                          </button>
                          {item.add_rec_net && (
                            <input
                              type="number"
                              id="add_rec_net_qty"
                              name="add_rec_net_qty"
                              value={item?.add_rec_net_qty ?? ''}
                              onWheel={(e) => e.target.blur()}
                              onChange={handleInputChange(index)}
                              onKeyDown={(e) => {
                                if (e.key === 'ArrowUp' || e.key === 'ArrowDown') {
                                  e.preventDefault();
                                }
                              }}
                              className="px-2 py-2 border rounded-md w-20 bg-orange-50"
                            />
                          )}
                        </>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>

          <div className='m-2 sm:m-5 flex flex-wrap gap-2'>
            {ingredientReceiptList.every(item => item.receipt_status != 1) && (
              <button
                onClick={handleSave}
                className="px-3 py-2 sm:px-4 sm:py-2 bg-blue-500 text-white rounded-md mr-4 hover:bg-blue-600 focus:outline-none focus:ring focus:ring-blue-200"
              >
                Save
              </button>
            )}
            <button
              onClick={handleAddNewIngredientRow}
              className="px-3 py-2 sm:px-4 sm:py-2 bg-blue-500 text-white rounded-md mr-4 hover:bg-blue-600 focus:outline-none focus:ring focus:ring-blue-200"
            >
              Add Ingredient
            </button>
            <button
              onClick={handleSubmit}
              className="px-3 py-2 sm:px-4 sm:py-2 bg-rose-500 text-white rounded-md mr-4 hover:bg-rose-600 focus:outline-none focus:ring focus:ring-rose-200"
            >
              Received
            </button>
          </div>
        </div>
      )}
    </div>
  )
}

export default ReceiptNetList;